import React, { useState } from 'react'
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  TextField,
} from '@material-ui/core'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ReactTooltip from 'react-tooltip'
import ExitIcon from '@material-ui/icons/ExitToApp'
import SaveIcon from '@material-ui/icons/Save'
import { useHistory } from 'react-router-dom'
import Swal from 'sweetalert2'
import { useAsistencia } from '../../../context/AsistenciaContext'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Table31 } from './Tables/TableSec3/Table31'
import { Table33 } from './Tables/TableSec3/Table33'
import { Table34 } from './Tables/TableSec3/Table34'
import { TableLinkedIn } from './Tables/TableSec3/TableLinkedIn'
import Typography from '@mui/material/Typography'
import { useFormTechnicalAssistance } from '../../../context/TechnicalAssistanceContext'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import swal from 'sweetalert'
import {
  UploadReportCapacityBuildingIFI,
  documentRequestNoObjection,
  insertTechnicalAssistanceAnswers,
} from '../../../services/AsistenciaTecnica/create'
import ROUTES from '../../../routers/routes'
import { LoadingButton } from '@mui/lab'
import { useAuthentication } from '../../../context/authenticationContext'
import { Table35 } from './Tables/TableSec3/Table35.js'
import DownloadIcon from '@mui/icons-material/Download'
import { validateEditForm } from '../../../services/Forms/create'

export const AsistenciaSeccion3 = (props) => {
  const { assistanceForm } = useFormTechnicalAssistance()

  const { goToStep, edit } = props
  const history = useHistory()
  const [, dispatch] = useAsistencia()
  const [saving, setSaving] = useState(false)
  const { userIDB2C, userFullName } = useAuthentication()

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 2 })
    goToStep(2)
  }

  const GeneralDataSchema = Yup.object().shape({
    SelectionProcessExplanation: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u0`0f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(2000, 'Máximo 2000 caracteres'),
    validateTable31: Yup.boolean().oneOf(
      [true],
      'Los datos de esta tabla son obligatorios',
    ),
    validateTable33: Yup.boolean().oneOf(
      [true],
      'Los datos de esta tabla son obligatorios',
    ),
    validateTable34: Yup.boolean().oneOf(
      [true],
      'Se debe de agregar un registro',
    ),
    UserAgreesAssistanceContract: Yup.boolean().oneOf(
      [true],
      'Este campo es obligatorio',
    ),
    NoObjectionRequestCambioII: Yup.boolean().oneOf(
      [true],
      'Este campo es obligatorio',
    ),
    validateTable35: Yup.boolean().oneOf(
      [true],
      'Se debe de agregar un registro',
    ),
  })

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      SelectionProcessExplanation:
        assistanceForm.SelectionProcessExplanation || '',
      validateTable31: false,
      validateTable33: false,
      validateTable34: false,
      UserAgreesAssistanceContract:
        assistanceForm.UserAgreesAssistanceContract || false,
      NoObjectionRequestCambioII:
        assistanceForm.UserAgreesAssistanceContract || false,
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      saveForm(values, false)
    },
  })

  const getRequestNoObjection = async () => {
    try {
      const response = await documentRequestNoObjection(
        assistanceForm.IdTechnicalAssistanceAnswer,
        userIDB2C,
      )
      if (response.Success) {
        console.log(
          ' response.Data.ReportTechnicalAssistanceAnswers.FileContents',
          response.Data,
        )
        const byteCharacters = atob(
          response.Data.ReportTechnicalAssistanceAnswers[0].FileContents,
        )
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const filename = 'Plantilla de Solicitud'
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        const link = document.createElement('a')

        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const uploadReport = async (idForm, IdFormHistory) => {
    try {
      const response = await UploadReportCapacityBuildingIFI(
        idForm,
        userIDB2C,
        IdFormHistory,
      )

      if (response.Success) {
        setSaving(false)
        swal({
          title: 'Formulario Enviado Exitosamente',
          icon: 'success',
          button: 'Entendido',
        })
        history.push('/')
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleChangeDeclaration = (e) => {
    switch (e.target.value) {
      case 'UserAgreesAssistanceContract':
        if (e.target.checked === true) {
          formik.setFieldValue('UserAgreesAssistanceContract', true)
        } else {
          formik.setFieldValue('UserAgreesAssistanceContract', false)
        }
        break

      case 'NoObjectionRequestCambioII':
        if (e.target.checked === true) {
          formik.setFieldValue('NoObjectionRequestCambioII', true)
        } else {
          formik.setFieldValue('NoObjectionRequestCambioII', false)
        }
        break

      default:
        formik.setValues({
          ...formik.values,
          UserAgreesAssistanceContract: false,
          NoObjectionRequestCambioII: false,
        })
        break
    }
  }

  const saveForm = async (values, borrador, exit) => {
    try {
      setSaving(true)
      let object
      if (!borrador) {
        object = {
          ...assistanceForm,
          ...values,
          Draft: false,
        }
      } else {
        object = {
          ...assistanceForm,
          ...values,
        }
      }

      const response = await insertTechnicalAssistanceAnswers({ ...object })
      if (response.Success) {
        if (borrador) {
          swal({
            title: 'Formulario Guardado',
            icon: 'success',
            button: 'Entendido',
          })

          if (exit) {
            if (edit) {
              history.push(ROUTES.IFIBORRADOR.pathname)
              dispatch({ type: 'SET_STATE', payload: 1 })
            } else {
              history.push('/')
              dispatch({ type: 'SET_STATE', payload: 1 })
            }
          }
        } else {
          uploadReport(
            response.Data.IdTechnicalAssistanceAnswersAnswer,
            response.Data.IdFormHistory,
          )
        }
      }
    } catch (error) {
      console.log('Error al guardar', error)
    }
  }

  const cancelForm = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await validateEditForm(
          userIDB2C,
          2,
          assistanceForm.IdTechnicalAssistanceAnswer,
        )

        if (response.Success) {
          const exit = true
          saveForm(formik.values, true, exit)
        }
      } else if (result.isDenied) {
        const response = await validateEditForm(
          userIDB2C,
          2,
          assistanceForm.IdTechnicalAssistanceAnswer,
        )
        if (response.Success) {
          if (edit) {
            history.push(ROUTES.IFIBORRADOR.pathname)
            dispatch({ type: 'SET_STATE', payload: 1 })
          } else {
            history.push('/')
            dispatch({ type: 'SET_STATE', payload: 1 })
          }
        }
      }
    })
  }

  return (
    <>
      <Grid
        container
        md={12}
        sm={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Grid item>
          <div
            data-tip
            data-for="exitPop"
            onClick={() => cancelForm()}
            style={{
              backgroundColor: 'red',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <ExitIcon style={{ transform: 'scaleX(-1)' }} />
            <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
              <span>Regresar</span>
            </ReactTooltip>
          </div>
        </Grid>
        <Grid item>
          <div
            onClick={() => saveForm(formik.values, true)}
            data-tip
            data-for="savePop"
            style={{
              backgroundColor: '#5cb85c',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <SaveIcon />
          </div>
          <ReactTooltip id="savePop" effect="solid" backgroundColor="#5cb85c">
            <span>Guardar Borrador</span>
          </ReactTooltip>
        </Grid>
      </Grid>

      <form id="Sec3-form">
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">
            Información sobre la Asistencia Técnica utilizada
          </h1>
          <br />
        </Grid>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.validateTable31 ? { border: '2px solid red' } : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              1. Términos de referencia para la asistencia técnica solicitada{' '}
              <span style={{ color: 'red' }}>*</span>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Adjunte los términos de referencia de la asistencia técnica
                  solicitada. Incluir información sobre:
                </label>
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">I) Objetivos</label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    II) Lista y descripción de productos y actividades
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    III) Presupuesto detallado
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">IV) Cronograma</label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    V) Resultados esperados de la construcción de capacidades,
                    junto con lo dispuesto para el monitoreo y evaluación para
                    dar seguimiento a la actividad
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    VI) Programación de pagos vinculados con la entrega de
                    productos esperados
                  </label>
                </Grid>
              </Grid>
              <Grid container spacing={1} className="input__container">
                <Table31
                  IdTechnicalAssistanceAnswer={
                    assistanceForm.IdTechnicalAssistanceAnswer
                  }
                  formik={formik.setFieldValue}
                />
                {formik.errors.validateTable31 ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.validateTable31}
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.SelectionProcessExplanation
                ? { border: '2px solid red' }
                : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              2. Proceso de selección del proveedor de servicios de asistencias
              técnicas que se utilizará, y forma de contratación{' '}
              <span style={{ color: 'red' }}>*</span>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Explique cuál es el procedimiento que utiliza la IFI para
                  seleccionar y contratar servicios de este tipo:
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Procesamiento utilizado para seleccionar y contratar servicios"
                    customInput={TextField}
                    value={formik.values.SelectionProcessExplanation}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'SelectionProcessExplanation',
                        e.target.value,
                      )
                    }}
                    maxLength={2000}
                  ></textarea>
                </FormControl>
                {formik.errors.SelectionProcessExplanation ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.SelectionProcessExplanation}
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.validateTable33 ? { border: '2px solid red' } : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3. Copia del borrador del contrato con el proveedor de servicios{' '}
              <span style={{ color: 'red' }}>*</span>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Adjunte la copia del borrador del contrato que se firmará con
                  el proveedor de servicios
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Table33
                  IdTechnicalAssistanceAnswer={
                    assistanceForm.IdTechnicalAssistanceAnswer
                  }
                  formik={formik.setFieldValue}
                />
                {formik.errors.validateTable33 ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.validateTable33}
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.validateTable34 ? { border: '2px solid red' } : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              4. Lista de posibles proveedores del servicio requerido{' '}
              <span style={{ color: 'red' }}>*</span>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Adjunte un CV/perfil detallado de los proveedores de servicios
                  propuestos, incluyendo los datos de contacto (teléfono,
                  dirección y correo electrónico, etc.)
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Table34
                  IdTechnicalAssistanceAnswer={
                    assistanceForm.IdTechnicalAssistanceAnswer
                  }
                  formik={formik.setFieldValue}
                />
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">Perfil LinkedIn</label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <TableLinkedIn
                    IdTechnicalAssistanceAnswer={
                      assistanceForm.IdTechnicalAssistanceAnswer
                    }
                    formik={formik.setFieldValue}
                  />
                </Grid>
                {formik.errors.validateTable34 ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.validateTable34}
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.validateTable35 ? { border: '2px solid red' } : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              5. Solicitud de No Objeción
              <span style={{ color: 'red' }}>*</span>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Descargue la plantila de la solicitud
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Button
                  variant="outlined"
                  startIcon={<DownloadIcon color="success" />}
                  onClick={() => getRequestNoObjection()}
                >
                  Plantilla de Solicitud
                </Button>
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Table35
                  IdTechnicalAssistanceAnswer={
                    assistanceForm.IdTechnicalAssistanceAnswer
                  }
                  formik={formik.setFieldValue}
                />
                {formik.errors.validateTable35 ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.validateTable35}
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Grid container spacing={1} className="input__container">
          <Grid item xs={12} sm={12} md={12}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    value="UserAgreesAssistanceContract"
                    checked={!!formik.values.UserAgreesAssistanceContract}
                    onChange={(e) => handleChangeDeclaration(e)}
                  />
                }
                label={
                  <>
                    Yo, <b>{userFullName}</b>, en nombre de{' '}
                    <b>{assistanceForm.NameIFI}</b>, me comprometo a contratar
                    la Asistencia Técnica reflejada en esta solicitud.
                    <span style={{ color: 'red' }}>*</span>
                  </>
                }
              />
              {formik.errors.UserAgreesAssistanceContract ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  {formik.errors.UserAgreesAssistanceContract}
                </div>
              ) : null}

              <FormControlLabel
                control={
                  <Checkbox
                    value="NoObjectionRequestCambioII"
                    checked={!!formik.values.NoObjectionRequestCambioII}
                    onChange={(e) => handleChangeDeclaration(e)}
                  />
                }
                label={
                  <>
                    Solicito al Programa CAMBIO II, la No Objeción para proceder
                    con la Asistencia Técnica para la construcción de
                    capacidades, y contratar al proveedor de servicios para su
                    desarrollo.
                    <span style={{ color: 'red' }}>*</span>
                  </>
                }
              />
              {formik.errors.NoObjectionRequestCambioII ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  {formik.errors.NoObjectionRequestCambioII}
                </div>
              ) : null}
            </FormGroup>
          </Grid>
        </Grid>

        <Grid container spacing={1} className="button__container">
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            style={{ textAlign: 'left' }}
            className="continerButtonNav"
          >
            <Button
              onClick={() => previous()}
              variant="contained"
              className="button__wizard button__previous"
            >
              Anterior
            </Button>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            style={{ textAlign: 'right' }}
            className="continerButtonNav"
          >
            <Grid container>
              <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
                <LoadingButton
                  loadingPosition="start"
                  variant="contained"
                  loading={saving}
                  className="button__wizard button__next"
                  onClick={() => validateFormStatus()}
                >
                  Registrar
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}
